"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetSensitivityLabelArguments = exports.SetSensitivityLabelOptions = void 0;
exports.SetSensitivityLabelOptions = [
    {
        name: "declarative-agent-manifest-file",
        questionName: "declarative-agent-manifest-path",
        type: "string",
        shortName: "d",
        description: "Specify the path for the Declarative Agent manifest. It can be either absolute path or relative path to the project root folder, with default at './appPackage/declarativeAgent.json'",
        required: true,
        default: "./appPackage/declarativeAgent.json",
    },
    {
        name: "sensitivity-label",
        type: "string",
        shortName: "s",
        description: "Specify the sensitivity label to be set.",
        required: true,
        skipValidation: true,
    },
];
exports.SetSensitivityLabelArguments = [];
//# sourceMappingURL=SetSensitivityLabelOptions.js.map